import { stepOrder } from "./const";

const RESUME_STEP_KEY = "resume_step";
// Giữ tiến trình 7 ngày, sau đó coi như khách mới.
const RESUME_STEP_TTL = 7 * 24 * 60 * 60 * 1000;

// Step nằm ngoài stepOrder nhưng vẫn thuộc luồng form (short form)
const stepAliases = {
  nextpaydatesort: "nextpaydate"
};

// Đi tới những trang này nghĩa là đã xong form, không còn gì để tiếp tục.
export const finalSteps = [
  "submit-lead",
  "requestcash",
  "mapping-lender",
  "configuration",
  "redirect",
  "redirect-upstart",
  "redirect-upgrade",
  "reject-page"
];

export const stepLabels = {
  lgname: "Your legal name",
  email: "Your contact email",
  cellphone: "Your cell phone",
  zip: "Your ZIP code",
  address: "Your home address",
  hometime: "Time at current address",
  ownhome: "Home ownership",
  incomesource: "Income source",
  emptime: "Time at current employer",
  unsecureddebtamount: "Unsecured debt amount",
  payfreequency: "Pay frequency",
  grossincome: "Monthly gross income",
  nextpaydate: "Next pay date",
  nextpaydatesort: "Next pay date",
  empinfor: "Employer information",
  workphone: "Work phone",
  deposit: "Direct deposit",
  aba: "ABA routing number",
  banktype: "Bank account type",
  banktime: "Time with your bank",
  bankaccount: "Bank account number",
  driverid: "Driver's license",
  owncar: "Car ownership",
  creditscore: "Credit score",
  ssn: "Social security number"
};

export const totalSteps = stepOrder.length;

export const getStepFromPath = (path = "") => {
  const step = String(path).split("?")[0].split("/").filter(Boolean).pop();
  return step ?? null;
};

export const isTrackableStep = (step) =>
  stepOrder.includes(step) || Object.keys(stepAliases).includes(step);

export const getStepNumber = (step) => {
  const index = stepOrder.indexOf(stepAliases[step] ?? step);
  return index < 0 ? null : index + 1;
};

export const getStepLabel = (step) => stepLabels[step] ?? "";

export const saveResumeStep = (step) => {
  if (!isTrackableStep(step)) return;
  try {
    localStorage.setItem(
      RESUME_STEP_KEY,
      JSON.stringify({ step, updatedAt: Date.now() })
    );
  } catch (_) {
    // localStorage không dùng được (private mode...) thì bỏ qua
  }
};

export const getResumeStep = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(RESUME_STEP_KEY) || "null");
    if (!saved || !isTrackableStep(saved.step)) return null;

    if (Date.now() - (saved.updatedAt ?? 0) > RESUME_STEP_TTL) {
      clearResumeStep();
      return null;
    }

    return saved.step;
  } catch (_) {
    return null;
  }
};

export const clearResumeStep = () => {
  try {
    localStorage.removeItem(RESUME_STEP_KEY);
  } catch (_) {
    // bỏ qua
  }
};
